export default "__VITE_ASSET__BoL_CvpS__"